import { render, staticRenderFns } from "./orderDIFOTSummaryDetailsWidget.vue?vue&type=template&id=669517d6&"
import script from "./orderDIFOTSummaryDetailsWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTSummaryDetailsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports